import { inject, Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { AuthService, NavigationData } from "@Services/auth.service";
import { Observable, of } from "rxjs";

/**
 * Resolver posizionato su tutte le rotte disponibili
 * per un utente del ticketing (tutto tranne **`/preventivo`**).
 *
 * Il resolver si occupa di:
 * - recuperare lo snapshot salvato prima del redirect **VERSO** keycloak.
 * - chiamare l'`AuthService` per settare i dati dello snapshot nei vari service
 *  recuperando la "sessione" dell'utente prima del login.
 * - settare a `true` il flag `isRestoringNavigationData` necessario al
 *  `BuyTicketlessComponent` per evitare logiche di redirect superflue
 *
 * Nel caso in cui non siano presenti dati di snapshot allora
 * risolve normalmente la rotta facendo proseguire invariata la logica
 * del `BuyTicketlessModule`.
 */
@Injectable({
  providedIn: 'root'
})
export class PostLoginDataRestoreResolver implements Resolve<boolean> {

  private authSvc = inject(AuthService);

  resolve(): Observable<boolean>{
    const redirectData = localStorage.getItem('redirect');

    if(redirectData){
      this.authSvc.isRestoringNavigationData.set(true);
      const redirectInfo: NavigationData = JSON.parse(redirectData);
      this.authSvc.restoreNavigationStateAfterLogin(redirectInfo);
    }

    return of(true);
  }
}
